export default "__VITE_ASSET__CHzy$OiH__"